export interface UsedSources { SourceId: string, ExactMatchedTexts: string[], MatchedLines: number[] }

export interface ChatGPTResponse {
    Answer: string
    UsedSources: UsedSources[]
}

export type pdfSource = { Type: "pdf", Title: string, Page: number, SourceId: string, IsGuid: string };

export type isDocumentationSource = { Type: "documentation", Title: string, Url: string, SourceId: string };

export type ticketSource = {
    Type: "ticket",
    Title: string,
    Text: string,
    SourceId: string,
    ProblemNr: number,
    FirstComment: string,
    LastComment: string,
    IsContainer: boolean,
    Hotliner: string,
    TicketType: string,
    Status: string,
    Deadline: Date | string,
    IsGuid: string
};

export type emailSource = {
    Type: "email",
    Title: string, // Subject
    Text: string,  // Snippet with sender
    SourceId: string, // "email_12345"
};


export type SourceItem = pdfSource | ticketSource | isDocumentationSource | emailSource;

export enum SearchState {
    WaitForInput = 0,
    LoadingSources = 1,
    ValidatingSources = 2
}

export interface ChatGPTPdfPreviewState {
    selectedDocumentInfo: SourceItem,
    searchResult?: SourceItem[],
    answer?: string,
    textToHighlight?: string[],
    checkedSources: ChatGPTResponse,
    searchstate: SearchState
}

export interface PagedSearchResult {
    Results: SourceItem[];
    HasMore: boolean;
}